import { render } from "./AuthenticationRequiredModal.vue?vue&type=template&id=2f87207b"
import script from "./AuthenticationRequiredModal.vue?vue&type=script&lang=js"
export * from "./AuthenticationRequiredModal.vue?vue&type=script&lang=js"

import "./AuthenticationRequiredModal.vue?vue&type=style&index=0&id=2f87207b&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__